import { takeLatest, call, put } from 'redux-saga/effects'
import lessonBlocksList from 'api/administration/blocks/List'
import * as fromActions from 'store/actions/blocks.action'
import { editEvaluationBlock } from 'api/administration/blocks/Edit'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}
async function editEvaluation(blockId: number, blockDetails: any) {
  return editEvaluationBlock(blockId, blockDetails)
}

function* editEvaluationBlockEffectSaga(action: any) {
  try {
    const {
      payload: {
        id,
        lessonId,
        details: { description, name },
        config: { approvalPoints, maxRetries, showResults, randomQuestions },
        uploadVersion,
      },
    } = action

    const blockDetails = {
      upload_version: uploadVersion,
      block_evaluation: {
        approval_points: approvalPoints,
        max_retries: maxRetries,
        show_results: showResults,
        random_questions: randomQuestions,
      },
      block_instance: {
        name,
        description,
        lesson_id: lessonId,
      },
    }

    yield call(editEvaluation, id, blockDetails)
    const data = yield call(getList, lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editEvaluationBlockWatcherSaga() {
  yield takeLatest(
    fromActions.EDIT_EVALUATION_BLOCK,
    editEvaluationBlockEffectSaga
  )
}
